import EcoSpace from 'eco-design/base/eco-space';
import Banner from '../../components/BannerA';
import DiySolarSystem from '../../components/DiySolarSystem';
import EcoAi from '../../components/EcoAi';
import FooterTcA from '../../components/FooterTcA';
import OnlineStoreRightsA2 from '../../components/OnlineStoreRightsA2';
import ProductList from '../../components/ProductList';
import SectionB1 from '../../components/SectionB1';
import SolarEnergy from '../../components/SolarEnergy';
import SolarInput from '../../components/SolarInput';
import SaveMoney from '../../components/SaveMoney';
import AcOutput from '../../components/AcOutput';
import PeaceOfMind from '../../components/PeaceOfMind';
import MultiLayered from '../../components/MultiLayered';
import EnergyBills from '../../components/EnergyBills';

export default function StatusItem() {
    return (
        <>
            <Banner />
            <div className="product-box">
                <EcoSpace hPc="160px" hPad="100px" hH5="80px" />
                <OnlineStoreRightsA2 />
                <ProductList />
                <EcoSpace hPc="160px" hPad="100px" hH5="80px" />
                <SaveMoney />
                <EcoSpace hPc="160px" hPad="100px" hH5="80px" />
                <SolarInput />
                <EcoSpace hPc="160px" hPad="100px" hH5="80px" />
                <AcOutput />
                <EcoSpace hPc="160px" hPad="100px" hH5="80px" />
                <PeaceOfMind />
                <EcoSpace hPc="160px" hPad="100px" hH5="80px" />
                <MultiLayered />
                <EcoSpace hPc="160px" hPad="100px" hH5="80px" />
                <SectionB1 />
                <EcoSpace hPc="160px" hPad="100px" hH5="80px" />
                <EcoAi pageType="na" />
                <SolarEnergy />
                <EcoSpace hPc="160px" hPad="0" hH5="0" />
                <EnergyBills />
                <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
                <DiySolarSystem />
                <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
                <FooterTcA />
            </div>
        </>
    );
}
